(function () {
  if (window.__rgWaterfallReviewStripInit) return;
  window.__rgWaterfallReviewStripInit = true;

  var rgSuppressCardClick = false;

  function initStripDrag(viewport) {
    if (!viewport || viewport.dataset.rgDragInit === '1') return;
    viewport.dataset.rgDragInit = '1';

    var ptrId = null;
    var startX = 0;
    var startScroll = 0;
    var dragging = false;
    var moved = false;
    var mouseDragGain = 1.65;

    function onDocMove(e) {
      if (!dragging || ptrId == null || e.pointerId !== ptrId) return;
      var dx = e.clientX - startX;
      var gain = e.pointerType === 'mouse' ? mouseDragGain : 1;
      var thresh = e.pointerType === 'mouse' ? 1 : 2;
      if (Math.abs(dx) > thresh) moved = true;
      var maxL = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      var next = startScroll - dx * gain;
      viewport.scrollLeft = Math.max(0, Math.min(maxL, next));
    }

    function onDocEnd(e) {
      if (!dragging) return;
      if (e.pointerId != null && e.pointerId !== ptrId) return;
      try {
        if (ptrId != null) viewport.releasePointerCapture(ptrId);
      } catch (err2) {}
      document.removeEventListener('pointermove', onDocMove);
      document.removeEventListener('pointerup', onDocEnd);
      document.removeEventListener('pointercancel', onDocEnd);
      dragging = false;
      viewport.classList.remove('rg-is-dragging');
      ptrId = null;
      if (moved) {
        rgSuppressCardClick = true;
        setTimeout(function () {
          rgSuppressCardClick = false;
        }, 50);
      }
    }

    viewport.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('button, a[href], input, textarea, select, label')) return;
        if (viewport.scrollWidth <= viewport.clientWidth + 1) return;
        ptrId = e.pointerId;
        startX = e.clientX;
        startScroll = viewport.scrollLeft;
        try {
          viewport.setPointerCapture(e.pointerId);
        } catch (err) {}
        dragging = true;
        moved = false;
        viewport.classList.add('rg-is-dragging');
        document.addEventListener('pointermove', onDocMove, { passive: true });
        document.addEventListener('pointerup', onDocEnd);
        document.addEventListener('pointercancel', onDocEnd);
      },
      { passive: true }
    );
  }

  if (!window.__rgReviewSheetDocClick) {
    window.__rgReviewSheetDocClick = true;
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.waterfall-review.rg [id^="rg-strip-"]').forEach(function (strip) {
        if (strip.contains(e.target)) return;
        strip.querySelectorAll('.rg-card--sheet-open').forEach(function (c) {
          c.classList.remove('rg-card--sheet-open');
        });
      });
    });
  }

  function initReviewSheetToggle(sectionId) {
    var strip = document.getElementById('rg-strip-' + sectionId);
    if (!strip || strip.dataset.rgSheetInit === '1') return;
    strip.dataset.rgSheetInit = '1';
    strip.querySelectorAll('.rg-card--has-media').forEach(function (card) {
      card.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        if (e.target.closest('.rg-overlay__sheet')) return;
        e.preventDefault();
        card.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      });
      card.addEventListener('click', function (e) {
        if (rgSuppressCardClick) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        if (e.target.closest('.rg-overlay__sheet')) {
          e.stopPropagation();
          return;
        }
        e.stopPropagation();
        var wasOpen = card.classList.contains('rg-card--sheet-open');
        strip.querySelectorAll('.rg-card--sheet-open').forEach(function (c) {
          c.classList.remove('rg-card--sheet-open');
        });
        if (!wasOpen) card.classList.add('rg-card--sheet-open');
      });
    });
  }

  function initStripAutoplay(wrap, viewport) {
    if (!wrap || !viewport || wrap.dataset.rgAutoplayInit === '1') return;
    wrap.dataset.rgAutoplayInit = '1';

    var on = wrap.getAttribute('data-rg-autoplay') === 'true';
    var intervalMs = parseInt(wrap.getAttribute('data-rg-interval-ms') || '5000', 10) || 5000;
    var slides = viewport.querySelectorAll('.rg-strip__slide');
    var apTimer = null;
    var resumeTimer = null;

    function gapPx() {
      var s = window.getComputedStyle(viewport);
      return parseFloat(s.columnGap || s.gap || '0', 10) || 0;
    }

    function slideStep() {
      if (!slides.length) return viewport.clientWidth;
      return slides[0].getBoundingClientRect().width + gapPx();
    }

    function clearAp() {
      if (apTimer) {
        clearInterval(apTimer);
        apTimer = null;
      }
    }

    function clearResume() {
      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function tick() {
      if (viewport.scrollWidth <= viewport.clientWidth + 2) return;
      var step = slideStep();
      var maxL = viewport.scrollWidth - viewport.clientWidth - 2;
      var next = viewport.scrollLeft + step;
      if (next >= maxL) {
        viewport.scrollLeft = 0;
      } else {
        viewport.scrollLeft = next;
      }
    }

    function start() {
      clearAp();
      clearResume();
      if (!on || slides.length < 2) return;
      if (viewport.scrollWidth <= viewport.clientWidth + 2) return;
      apTimer = setInterval(tick, intervalMs);
    }

    function pauseAndScheduleResume() {
      clearAp();
      if (!on || slides.length < 2) return;
      clearResume();
      var resumeAfter = Math.max(350, Math.round(intervalMs * 0.35));
      resumeTimer = setTimeout(function () {
        resumeTimer = null;
        start();
      }, resumeAfter);
    }

    function onStripEnter() {
      clearAp();
      clearResume();
    }

    function onStripLeave() {
      clearResume();
      resumeTimer = setTimeout(function () {
        resumeTimer = null;
        start();
      }, 280);
    }

    function onVis() {
      if (document.hidden) {
        clearAp();
        clearResume();
      } else {
        start();
      }
    }

    wrap.addEventListener('mouseenter', onStripEnter);
    wrap.addEventListener('mouseleave', onStripLeave);
    viewport.addEventListener('pointerdown', pauseAndScheduleResume);
    document.addEventListener('visibilitychange', onVis);

    wrap._rgAutoplayCleanup = function () {
      clearAp();
      clearResume();
      wrap.removeEventListener('mouseenter', onStripEnter);
      wrap.removeEventListener('mouseleave', onStripLeave);
      viewport.removeEventListener('pointerdown', pauseAndScheduleResume);
      document.removeEventListener('visibilitychange', onVis);
    };

    start();
  }

  function resetSection(sectionId) {
    var wrap = document.getElementById('rg-strip-' + sectionId);
    if (wrap && wrap._rgAutoplayCleanup) wrap._rgAutoplayCleanup();
    if (wrap) wrap.dataset.rgAutoplayInit = '0';
    var vp = document.getElementById('rg-strip-viewport-' + sectionId);
    if (vp) vp.dataset.rgDragInit = '0';
    var strip = document.getElementById('rg-strip-' + sectionId);
    if (strip) strip.dataset.rgSheetInit = '0';
  }

  function bootSection(sectionId) {
    initReviewSheetToggle(sectionId);
    var wrap = document.getElementById('rg-strip-' + sectionId);
    var viewport = wrap && wrap.querySelector('[data-rg-viewport]');
    if (viewport) initStripDrag(viewport);
    if (wrap && viewport) initStripAutoplay(wrap, viewport);
  }

  function stripSectionIds() {
    var ids = [];
    document
      .querySelectorAll('.waterfall-review.rg [id^="rg-strip-"]:not([id^="rg-strip-viewport-"])')
      .forEach(function (el) {
        var sid = el.id.replace(/^rg-strip-/, '');
        if (sid && ids.indexOf(sid) === -1) ids.push(sid);
      });
    return ids;
  }

  function bootAll() {
    stripSectionIds().forEach(bootSection);
  }

  function onSectionLoad(e) {
    var root = e.target;
    if (!root || !root.querySelector) return;
    var wrap = root.querySelector(
      '.waterfall-review.rg [id^="rg-strip-"]:not([id^="rg-strip-viewport-"])'
    );
    if (!wrap) return;
    var sectionId = wrap.id.replace(/^rg-strip-/, '');
    if (!sectionId) return;
    resetSection(sectionId);
    bootSection(sectionId);
  }

  function onSectionUnload(e) {
    var root = e.target;
    if (!root || !root.querySelector) return;
    var wrap = root.querySelector(
      '.waterfall-review.rg [id^="rg-strip-"]:not([id^="rg-strip-viewport-"])'
    );
    if (!wrap || !wrap._rgAutoplayCleanup) return;
    wrap._rgAutoplayCleanup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
